// Auto-generated from root CHANGELOG.md — do not edit manually
import { ChangelogEntry } from '../utils/changelog';

export const changelog: ChangelogEntry[] = [
  {
    "version": "0.1",
    "date": "2025-02-04",
    "changes": [
      "Playbooks: Create custom rule sets for document review, import from existing documents, and AI-assisted playbook generation",
      "Meeting Assistant: Integration with Queri Voice for meeting transcription, summaries, and automatic contract drafting",
      "Knowledge Base: Connect your documents to Q-Chat for AI-powered search and retrieval",
      "UI Refresh: New modern interface with improved navigation and consistent styling"
    ]
  }
];
